import script from "./dupliPopUp3.vue?vue&type=script&setup=true&lang=js"
export * from "./dupliPopUp3.vue?vue&type=script&setup=true&lang=js"

import "./dupliPopUp3.vue?vue&type=style&index=0&id=449fd81b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-449fd81b"]])

export default __exports__